import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from "react-router-dom";
import Login from "../pages/auth/Login";
import DashBoard from "../pages/dash-board/DashBoard";
import QRCodeScanner from "../pages/scanner/QRCodeScanner";
import ChangePassword from "../pages/auth/ChangePassword";

const AppRoutes = ({
  isAuthenticated,
  setIsAuthenticated,
  employeeInfo,
  setEmployeeInfo,
  scanData,
  setScanData,
  setIsAdminAuthenticated,
  isAdminAuthenticated,
  setIsAdmin,
  isAdmin,
}) => {
  // Check authentication status from local storage
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    setIsAuthenticated(!!user);
    setAuthChecked(true);
  }, []);

  if (!authChecked) return null; // Prevents flicker
  return (
    <Router>
      <Routes>
        {isAuthenticated ? (
          <>
            {/* Authenticated routes */}
            <Route path="/mobile/dashboard" element={<DashBoard />} />
            <Route
              path="/mobile/scan"
              element={
                <QRCodeScanner
                  employeeInfo={employeeInfo}
                  setScanData={setScanData}
                />
              }
            />
            <Route
              path="/mobile/change-password/:id"
              element={
                <ChangePassword setIsAuthenticated={setIsAuthenticated} />
              }
            />
            <Route
              path="*"
              element={<Navigate to="/mobile/dashboard" replace />}
            />
          </>
        ) : (
          <>
            {/* Unauthenticated routes */}
            <Route
              path="/mobile/login"
              element={
                <Login
                  setIsAuthenticated={setIsAuthenticated}
                  setEmployeeInfo={setEmployeeInfo}
                  setScanData={setScanData}
                />
              }
            />
            <Route
              path="/mobile/forgot-password/:id"
              element={
                <ChangePassword setIsAuthenticated={setIsAuthenticated} />
              }
            />
            <Route path="*" element={<Navigate to="/mobile/login" replace />} />
          </>
        )}
      </Routes>
    </Router>
  );
};

export default AppRoutes;
